import React, { Fragment, PureComponent } from 'react';
import { object, func, bool, string } from 'prop-types';
import LoginSignUpModal, { LOGIN_SIGN_UP_MODAL } from '../LoginSignUpModal';
import MaryMagicSurveyModal from '../MaryMagicSurvey/MaryMagicSurveyModal';
import { MARY_MAGIC_SURVEY_MODAL } from '../../constants/modalIds';
import withAuthentication from '../../core/login/withAuthentication';
import DelaysModal, { DELAYS_MODAL } from '../Waitlist/DelaysModal';
import FullScreenPrompt, { FULL_SCREEN_PUSH_PROMPT_MODAL } from '../NativePush/FullScreenPrompt';

// TODO: make this lazy load modals with dynamic imports
class ModalController extends PureComponent {
  static propTypes = {
    closeModal: func,
    runtime: object,
    hasSubmittedMaryMagicSurvey: bool,
    accountSummary: object,
    createUserProfile: func,
    login: object,
    isLoggedIn: bool,
  };

  componentDidUpdate = prevProps => {
    if (!prevProps.isLoggedIn && this.props.isLoggedIn) {
      this.closeModal(LOGIN_SIGN_UP_MODAL)();
    }
  };

  closeModal = modalId => () => this.props.closeModal(modalId);

  render() {
    const { runtime, hasSubmittedMaryMagicSurvey, login } = this.props;
    const modal = runtime.modal || {};

    return (
      <Fragment>
        <LoginSignUpModal
          open={!!modal[LOGIN_SIGN_UP_MODAL]}
          onClose={this.closeModal(LOGIN_SIGN_UP_MODAL)}
          runtime={runtime}
          login={login}
        />
        {!hasSubmittedMaryMagicSurvey && (
          <MaryMagicSurveyModal
            open={!!modal[MARY_MAGIC_SURVEY_MODAL]}
            onClose={this.closeModal(MARY_MAGIC_SURVEY_MODAL)}
          />
        )}
        <DelaysModal
          open={!!modal[DELAYS_MODAL]}
          onClose={this.closeModal(DELAYS_MODAL)}
          runtime={runtime}
        />
        <FullScreenPrompt
          open={!!modal[FULL_SCREEN_PUSH_PROMPT_MODAL]}
          onClose={this.closeModal(FULL_SCREEN_PUSH_PROMPT_MODAL)}
        />
      </Fragment>
    );
  }
}

export default withAuthentication(ModalController);
